export default "/images/61aeb143b312326ac3ce103972eb8eb8.avif";